/**
 * Shared /api/cases filters for Investigation list + Investigation pipeline Kanban.
 * Keep both screens on the same dataset so counts and rows match.
 *
 * All new cases are written with case_type=INVESTIGATION (CaseController and ActionExecutor
 * both enforce this). Legacy types (SMR, SUSPICIOUS, UAR) are kept in the filter so that
 * existing rows created before the standardisation remain visible in the workspace.
 * No data migration of old rows is planned — the broad filter is the compatibility shim.
 */
export const INVESTIGATION_WORKSPACE_CASE_TYPES = 'INVESTIGATION,SMR,SUSPICIOUS,UAR'
export const INVESTIGATION_WORKSPACE_PAGE_SIZE = 50
/** Legacy constant kept for any callers that still reference it. */
export const INVESTIGATION_WORKSPACE_LIMIT = INVESTIGATION_WORKSPACE_PAGE_SIZE

/** Pipeline stage id → cases.status values (comma list for GET /api/cases?status=). */
export const PIPELINE_STAGE_STATUSES = {
  investigation: 'OPEN,INVESTIGATING,ESCALATED',
  pending_evidence: 'PENDING_EVIDENCE',
  suspicion_formed: 'SUSPICION_FORMED',
  smr_draft: 'SMR_DRAFT,PENDING_REVIEW',
  under_review: 'PENDING_APPROVAL',
  filed: 'FILED',
  closed: 'CLOSED,RESOLVED',
}

export function buildInvestigationWorkspaceCasesQuery({
  assignedToMe,
  patron_id,
  member_id,
  visitor_id,
  subject_type,
  pipeline_stage,
  page = 1,
  limit = INVESTIGATION_WORKSPACE_PAGE_SIZE,
} = {}) {
  const params = new URLSearchParams({
    case_type: INVESTIGATION_WORKSPACE_CASE_TYPES,
    limit: String(limit),
    page: String(page),
  })
  if (assignedToMe) params.set('assigned_to_me', 'true')
  if (patron_id?.trim()) params.set('patron_id', patron_id.trim())
  if (member_id?.trim()) params.set('member_id', member_id.trim())
  if (visitor_id?.trim()) params.set('visitor_id', visitor_id.trim())
  if (subject_type?.trim()) params.set('subject_type', subject_type.trim())
  const statuses = PIPELINE_STAGE_STATUSES[String(pipeline_stage || '').trim()]
  if (statuses) params.set('status', statuses)
  return params
}
